import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-52092804"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import { computed } from "vue"
import { ViewPerson } from "@/rd/ResearchDataModel"

// NOTE: This component is used in search results that do NOT have access to stores


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonListItem',
  props: {
    person: {},
    isUser: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const genderClassRef = computed(() => [props.person?.displayProperties.gender?.toLowerCase()])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["person-list-item", { 'user': _ctx.isUser, disabled: _ctx.disabled }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["gender-bar", genderClassRef.value])
    }, null, 2),
    _hoisted_1,
    (_ctx.person)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.person.displayName) + " ", 1),
          (_ctx.person.birthYear)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, "(" + _toDisplayString(_ctx.person.birthYear) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})